export function initialSetup(selfClass,o){

}
